import { render } from "./AgregarSuperAdministrador.vue?vue&type=template&id=600c3c74&scoped=true"
import script from "./AgregarSuperAdministrador.vue?vue&type=script&lang=js"
export * from "./AgregarSuperAdministrador.vue?vue&type=script&lang=js"

import "./AgregarSuperAdministrador.vue?vue&type=style&index=0&id=600c3c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600c3c74"]])

export default __exports__